import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {styles} from './CreateDocumentModal.styles';
import {REPORT_TYPE_OPTIONS} from './CreateDocumentModal.utils';

export const SourceReportTypeSelect = ({
  setSourceReportType,
  sourceReportType,
}) => {
  return (
    <Stack>
      <Typography pb={1} style={styles.modal.label}>
        Report type of uploaded document *
      </Typography>
      <Select
        onChange={(e) => setSourceReportType(e.target.value)}
        sx={styles.modal.select}
        value={sourceReportType}
      >
        {REPORT_TYPE_OPTIONS.map(({label, type}) => (
          <MenuItem key={type} value={type}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

SourceReportTypeSelect.propTypes = {
  setSourceReportType: PropTypes.func.isRequired,
  sourceReportType: PropTypes.string.isRequired,
};
